// src/pages/NotFound.jsx — page 404
import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button, Stack } from "@mui/material";
import HomeIcon      from "@mui/icons-material/Home";
import SchoolIcon    from "@mui/icons-material/School";
import { P }         from "../theme";

export default function NotFound() {
  return (
    <Box sx={{
      minHeight: "70vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      px: 3,
    }}>
      {/* Numéro 404 */}
      <Typography sx={{
        fontSize: { xs: "6rem", md: "9rem" },
        fontWeight: 900,
        lineHeight: 1,
        color: P.slate[100],
        userSelect: "none",
        mb: -1,
      }}>
        404
      </Typography>

      {/* Icône */}
      <Box sx={{
        width: 80, height: 80, borderRadius: "50%",
        background: `${P.navy}12`,
        display: "flex", alignItems: "center", justifyContent: "center",
        mb: 3,
      }}>
        <SchoolIcon sx={{ fontSize: 40, color: P.navy }} />
      </Box>

      <Typography sx={{ fontWeight: 800, fontSize: "1.4rem", color: P.slate[800], mb: 1 }}>
        Page introuvable
      </Typography>
      <Typography sx={{ color: P.slate[500], maxWidth: 400, mb: 4, lineHeight: 1.6 }}>
        La page que vous cherchez n'existe pas ou a été déplacée.
      </Typography>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <Button
          component={Link} to="/"
          variant="contained"
          startIcon={<HomeIcon />}
          sx={{
            background: P.navy,
            "&:hover": { background: P.navyL },
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "8px",
            px: 3,
          }}
        >
          Accueil
        </Button>
        <Button
          component={Link} to="/exams"
          variant="outlined"
          startIcon={<SchoolIcon />}
          sx={{
            borderColor: P.navy,
            color: P.navy,
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "8px",
            px: 3,
          }}
        >
          Voir les examens
        </Button>
      </Stack>
    </Box>
  );
}